import React from 'react';
import { Control, FieldValues, useController } from 'react-hook-form';
import { Checkbox, FormHelperText, VStack, CheckboxProps } from '@chakra-ui/react';

export const CheckboxControl = ({
    control,
    label,
    defaultChecked = false,
    description = '',
    flexDirection = 'column',
    name,
    ...props
}: CheckboxProps & {
    control: Control<FieldValues>;
    label: string;
    defaultChecked?: boolean;
    description?: string;
    name: string;
}) => {
    const hasDescription = Boolean(description);
    const isRow = flexDirection === 'row';
    const {
        field: { value, ...inputProps },
    } = useController({
        name,
        control,
        // defaultValue: null,
        defaultValue: defaultChecked,
    });

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;
        inputProps.onChange(checked);
    };

    return (
        <VStack spacing={1} align="start">
            <Checkbox
                name={name}
                onChange={onChange}
                isChecked={value || false}
                data-test-id={`field-${name}`}
                {...props}
            >
                {label}{' '}
                {hasDescription && isRow && (
                    <FormHelperText display="inline-block" pl={2}>
                        {description}
                    </FormHelperText>
                )}
            </Checkbox>
            {hasDescription && !isRow && <FormHelperText pl={0}>{description}</FormHelperText>}
        </VStack>
    );
};
